import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-pulse-participation',
  templateUrl: './pulse-participation.component.pug',
  styleUrls: ['./pulse-participation.component.scss'],
  standalone: false
})
export class PulseParticipationComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() request!: any;
  @Input() survey!: any;
  @Input() department!: any;
  @Input() filterBy!: any;
  state = 'participated'
  previousState = '';

  constructor(private permissions: PermissionsService) {
  }

  switchState(newState) {
    if (this.previousState !== newState) {
      this.state = newState;
      this.previousState = newState;
    }
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }


}
